export const EmailSearchFormFields = {
  email: 'email',
} as const;
